import { tech_logo } from '../types';
import { getTechLogoUrl } from '../utils/cloudinary';

// Map tech_logo enum values to Cloudinary image names
const techLogoMap: Record<string, string> = {
    [tech_logo.python]: 'python_logo',
    [tech_logo.android]: 'android_logo',
    [tech_logo.aws]: 'aws_logo',
    [tech_logo.firebase]: 'firebase_logo',
    [tech_logo.java]: 'java_logo',
    [tech_logo.react]: 'react_logo',
    [tech_logo.springboot]: 'springboot_logo',
    [tech_logo.typescript]: 'typescript_logo',
    [tech_logo.django]: 'django_logo',
    [tech_logo.prisma]: 'prisma_logo',
    [tech_logo.tanstack]: 'tanstack_logo',
    [tech_logo.supabase]: 'supabase_logo',
    [tech_logo.graphql]: 'graphql_logo',
    [tech_logo.apollo]: 'apollo_logo',
    [tech_logo.docker]: 'docker_logo',
    [tech_logo.figma]: 'figma_logo',
    [tech_logo.expo]: 'expo_logo',
    [tech_logo.kubernetes]: 'kubernetes_logo',
};

export const techLogoToPicture = (logo: string): string => {
    const imageName = techLogoMap[logo];
    if (!imageName) return "";
    return getTechLogoUrl(imageName);
};
